import React from "react";
import { Box, Typography, Link } from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        py: 4,
        textAlign: "center",
      }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mx: 4 }}>
        Braindecode - EEG Finetune Arena -{" "}
        <Link
          href="https://braindecode.org"
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
        >
          braindecode.org
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
